import { FC } from "react";
import Section from "components/corphurusato/parts/Section";
import Headline, { Big, Sep } from "components/corphurusato/parts/Headline";
import Content from "components/corphurusato/parts/Content";
import Paragraph from "components/corphurusato/parts/Paragraph";
import styled from "styled-components";

const AboutCorpAnimeHurusato: FC = () => {
  return (
    <Section>
      <Headline color={"#DE077D"}>
        <Sep>企業版</Sep>
        <Sep>
          <Big>アニメふるさと納税</Big>とは
        </Sep>
      </Headline>
      <Content>
        <Paragraph>アニメファンドのサービス内での特有の呼び名です。</Paragraph>
        <Paragraph>アニメファンドでは「自治体×アニメのコラボプロジェクト」に特化して掲載しています。</Paragraph>
        <Paragraph>
          ファンの皆様に皆様に「個人版のアニメふるさと納税」、企業の皆様に「企業版のアニメふるさと納税」で
          <PcBreak/>
          プロジェクトを応援いただき、&quot;アニメの力で自治体を盛り上げる&quot;ために活用しています。
        </Paragraph>
        <ImageArea>
          <Picture>
            <source srcSet="/image/lp/corphurusato/about_anime/figure_03_pc.png" media="(min-width: 960px)" />
            <img src="/image/lp/corphurusato/about_anime/figure_03_sp.png" alt="企業版アニメふるさと納税とは" />
          </Picture>
        </ImageArea>
      </Content>
    </Section>
  );
};

export default AboutCorpAnimeHurusato;

const PcBreak = styled.br`
  @media screen and (max-width: 960px) {
    display: none;
  }
`;

const ImageArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 960px) {
    margin: 20px auto;
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`;

const Picture = styled.picture`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;

  & > source,
  & > img {
    width: 100%;
  }
`;
